// extracted by mini-css-extract-plugin
export default {"navDesktop":"styles_navDesktop__E7-pi","ul":"styles_ul__ZWfQR","navMobile":"styles_navMobile__yRzwX"};